import { combineReducers } from '@reduxjs/toolkit';

import commonDetailReducer from './commonReducer';

const RootReducer = combineReducers({
  commonDetails: commonDetailReducer.reducer
});

export default RootReducer;
